import { defineComponent as _defineComponent } from 'vue'
import router from '@/router'
import { computed, getCurrentInstance, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const currentComp: any = getCurrentInstance()?.proxy

const breadcrumbs = ref<any[]>([])
const route = computed(() => currentComp?.$route)
const routes = computed(() => currentComp?.$router.options.routes)
const showBreadcrumbs = computed(() => {
  const list: any[] = []
  breadcrumbs.value.map((route, idx) => {
    const obj = {
      name: route.meta.breadcrumb.name,
      path: idx === breadcrumbs.value.length - 1 ? null : route.path,
    }
    list.push(obj)
  })
  return list
})

watch(
  () => route,
  () => {
    breadcrumbs.value = getAllBreadcrumb(route.value)
  },
  { immediate: true, deep: true }
)

function handleBreadcrumb(route: any) {
  if (!route.path) return
  router.push(route.path)
}

// 获取所有面包屑路由
function getAllBreadcrumb(cutRoute: any) {
  const { meta } = cutRoute
  if (!meta?.breadcrumb?.parent) return []
  let breadcrumbs: any[] = []
  while (cutRoute) {
    getNext(cutRoute)
  }
  function getNext(route: any) {
    if (!route.meta?.breadcrumb) cutRoute = false
    breadcrumbs.push(route)
    cutRoute = getRouterByName(routes.value, route.meta.breadcrumb.parent)
  }

  return breadcrumbs.reverse()
}

// 获取指定名称的路由信息
function getRouterByName(router: any[], name: string) {
  let target: any
  for (const route of router) {
    if (target) break
    if (route.name === name) {
      target = route
      break
    }
    if (route.children && route.children.length) {
      target = getRouterByName(route.children, name)
    }
  }
  return target
}

return { __sfc: true,currentComp, breadcrumbs, route, routes, showBreadcrumbs, handleBreadcrumb, getAllBreadcrumb, getRouterByName }
}

})